/**
 * Footer — bottom bar primitive used by RootLayout.
 * Version + tagline + GitHub link.
 */

import { footerCopy } from "./Footer.copy";

export function Footer(): React.ReactElement {
  const sep = (
    <span aria-hidden style={{ color: "var(--paper-cream-faint)" }}>{footerCopy.separator}</span>
  );
  return (
    <footer
      data-testid="chrome-footer"
      className="font-plex-mono text-paper-cream-dim"
      style={{
        display: "flex", alignItems: "center", gap: "0.5rem",
        padding: "16px 24px", fontSize: "0.781rem",
        borderTop: "1px solid var(--ledger-line)",
      }}
    >
      <span>animachord {footerCopy.version}</span>{sep}
      <span>{footerCopy.tagline}</span>{sep}
      <a
        href={footerCopy.githubHref}
        target="_blank" rel="noreferrer noopener"
        className="text-paper-cream-dim"
        style={{ textDecoration: "underline" }}
      >
        {footerCopy.githubLabel}
      </a>
    </footer>
  );
}

export default Footer;
